import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "text-sm text-slate-500 mb-3"
};
const _hoisted_2 = ["disabled"];
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { updateAssetTags } from '@/api/assets';
export default {
  __name: 'AssetTagsEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    asset: {
      type: Object,
      default: null
    },
    tagList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const selectedTagIds = ref([]);
    const submitting = ref(false);
    watch(() => props.visible, val => {
      if (val && props.asset) {
        selectedTagIds.value = (props.asset.tags || []).map(t => t.id);
      }
    });
    async function handleSubmit() {
      submitting.value = true;
      try {
        await updateAssetTags(props.asset.id, {
          tagIds: selectedTagIds.value
        });
        ElMessage.success('标签已更新');
        emit('success');
        emit('update:visible', false);
      } catch {
        // handled by interceptor
      } finally {
        submitting.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "编辑素材标签",
        width: "420px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: submitting.value,
          onClick: handleSubmit
        }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_2)]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_1, "素材：" + _toDisplayString(__props.asset?.name), 1), _createVNode(_component_el_select, {
          modelValue: selectedTagIds.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedTagIds.value = $event),
          multiple: "",
          placeholder: "选择标签",
          class: "w-full",
          clearable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tagList, tag => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: tag.id,
              label: tag.name,
              value: tag.id
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                class: "inline-block w-2.5 h-2.5 rounded-full mr-1.5",
                style: _normalizeStyle({
                  backgroundColor: tag.color || '#94a3b8'
                })
              }, null, 4), _createTextVNode(" " + _toDisplayString(tag.name), 1)]),
              _: 2
            }, 1032, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};